import { useCallback, useRef, useEffect } from 'react';
export function useParentIndicators(parentComment, parentCommentRef) {
    const commentElements = useRef({});
    const verticalIndicatorElements = useRef({});
    const setVerticalIndicatorRef = useCallback((commentId, element)=>{
        verticalIndicatorElements.current[commentId] = element;
    }, []);
    const setCommentRef = useCallback((commentId, element)=>{
        if (!element) {
            return;
        }
        commentElements.current[commentId] = element;
    }, []);
    const onCommentMouseOver = useCallback((commentId, parentId, isReplyingToParent)=>{
        if (!parentId || !commentElements.current[commentId] || !verticalIndicatorElements.current[commentId] || isReplyingToParent) {
            return;
        }
        let parentNode = null;
        if (parentComment && parentComment.commentId === parentId && parentCommentRef) {
            parentNode = parentCommentRef.current;
        } else {
            parentNode = commentElements.current[parentId];
        }
        if (!parentNode) {
            return;
        }
        const { top: commentTop } = commentElements.current[commentId].getBoundingClientRect();
        const { top: parentTop } = parentNode.getBoundingClientRect();
        verticalIndicatorElements.current[commentId].style.height = `${commentTop - parentTop - 20}px`;
    }, [
        parentComment,
        parentCommentRef
    ]);
    useEffect(()=>{
        if (parentComment && parentCommentRef) {
            setCommentRef(parentComment.commentId, parentCommentRef.current);
        }
    }, [
        parentComment,
        parentCommentRef,
        setCommentRef
    ]);
    return {
        setVerticalIndicatorRef,
        setCommentRef,
        onCommentMouseOver
    };
}

//# sourceMappingURL=useParentIndicators.js.map